export default "__VITE_ASSET__Bds9JJq___"